import { ComboboxItem, Select, SelectProps } from '@mantine/core';
import { useGetEnums } from 'api-hooks/common';
import React from 'react';
interface SaleTypeSelectProps extends SelectProps {}

export default function SaleTypeSelect(props: SaleTypeSelectProps) {
  const query = useGetEnums({
    class: 'sale-transaction-type',
  });

  const data: ComboboxItem[] = query.data?.data || [];
  return (
    <Select
      {...props}
      data={data}
      disabled={query.isLoading || props.disabled}
    />
  );
}
